import { apiMiddleware } from 'redux-api-middleware';
import { configureStore as configStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import { createBrowserHistory, createMemoryHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import rootReducer from 'config/rootReducer';

import getBasePath from 'bento-ordering/utils/getBasePath';

// Cache basePath set on full page load
const _basename = getBasePath();

export const browserHistory = createBrowserHistory({
  basename: _basename
});

browserHistory.listen(() => {
  // This is required to prevent client side navigation between 2 base paths
  // from creating a broken application state.
  if (_basename !== getBasePath()) {
    window.location.reload();
  }
});

export const testHistory = createMemoryHistory({
  basename: _basename
});

export const configureStore = (preloadedState, history = browserHistory) => {
  return configStore({
    reducer: rootReducer(history),
    middleware: [apiMiddleware, thunk, routerMiddleware(history)],
    preloadedState
  });
};
